const localization = {
  nl: {
    introductionTitle: 'Uw avontuur in de Vulkaaneifel begint hier',
    introductionP1: 'De wandelingen beginnen letterlijk aan de voordeur. Het vakantiehuis is gelegen in het rustige dorp Kopp, ongeveer 11 km ten zuidwesten van het kuuroord Gerolstein en 17 km ten zuidoosten van Prüm.',
    introductionP2: 'Het huis is jaren in het bezit geweest van een wandelvereniging, dat is natuurlijk niet zomaar. In de prachtige omgeving (de Vulkaaneifel heeft de titel UNESCO Global Geopark) kan men vele mooie wandelingen maken maar natuurlijk ook fietsen, motorrijden en in de winter zelfs langlaufen.',
    introductionButton: 'Meer over het huis',
    introductionButtonTarget: '/hethuis',
    introductionSlider1Alt: 'Het huis',
    introductionSlider2Alt: 'Eetruimte',
    introductionSlider3Alt: 'Terras met veranda',
    introductionSlider4Alt: 'Trampoline',
    introductionSlider5Alt: 'Natuur zomer',
    introductionSlider6Alt: 'Natuur winter',
    reviewsTitle: 'Verslagen en recenties',
    reviewsP1: '"Jaarlijks organiseren we een familieweek. Tijdens deze week verblijven we op een camping in het Zuiden van het land en maken we veel wandeltochten, fietstochten en dagtripjes naar lokale bezienswaardigheden."',
    reviewsP2: '"Het zat er al een tijdje aan te komen, een van mijn kinderen vroeg: "Gaan we dit jaar alweer naar diezelfde camping?". Dit jaar zijn we met de hele familie dus maar wat verder doorgereden en hebben we hier geen moment spijt van gehad!"',
    reviewsButton: 'Lees meer ervaringen op Micazu',
    reviewsButtonTarget: 'https://www.micazu.nl/over-de-verhuurder/62981/?houseId=25188'
  },
  de: {
    introductionTitle: 'Ihr Abenteuer in der Vulkaneifel beginnt hier',
    introductionP1: 'Die Wanderungen beginnen buchstäblich vor der Haustür des “Ferienhaus Vulkaneifel Kopp”. Das Haus befindet sich im ruhigen Ortschaft Kopp, ca. 11 km südwestlich von der Kurstadt Gerolstein und 17 km südöstlich von Prüm.',
    introductionP2: 'Das Haus wurde 1984 erbaut und war seit Jahren im Besitz eines Wandervereins. Das ist logisch. In der schönen Umgebung (die Vulkaneifel hat den Titel UNESCO Global Geopark) kann man viele schöne Wanderungen machen und natürlich auch Radfahren, Motorradfahren und sogar Langlaufen im Winter.',
    introductionButton: 'Mehr über das Haus',
    introductionButtonTarget: '/dashaus',
    introductionSlider1Alt: 'Das Haus',
    introductionSlider2Alt: 'Esszimmer',
    introductionSlider3Alt: 'Terrase mit Veranda',
    introductionSlider4Alt: 'Trampolin',
    introductionSlider5Alt: 'Natur im Sommer',
    introductionSlider6Alt: 'Natur im Winter',
    reviewsTitle: 'Erfahrungen und Bewertungen',
    reviewsP1: '"Jedes Jahr organisieren wir eine Familienwoche. Während dieser Woche bleiben wir auf einem Campingplatz im Süden des Landes und machen viele Wanderungen, Fahrradtouren und Tagesausflüge zu lokalen Sehenswürdigkeiten."',
    reviewsP2: '"Letstes Jahr fragte eines meiner Kinder: "Gehen wir wieder zu diesem langweiligen Campingplatz?". So nahmen wir dieses Jahr die ganze Familie mit zur Vulkaneifel und bereuten es nicht für einen Moment!"',
    reviewsButton: 'Lesen Sie mehr Erfahrungen auf Micazu',
    reviewsButtonTarget: 'https://www.micazu.de/ihr-gastgeber/62981/?houseId=25188'
  },
  en: {
    introductionTitle: 'Your adventure in the Vulkaneifel starts here',
    introductionP1: 'The hiking trails literally start at the front door. This holiday home is located in the quiet village of Kopp, about 11 km southwest of the spa town of Gerolstein and 17 km to the southeast of Prüm.',
    introductionP2: 'The house has previously been in the possession of a hiking club for many years and this is no coincidence. You can make many walks in the beautiful surroundings (the Vulkaneifel has been awarded the UNESCO Global Geopark title) but also cycle, motorcycle and in the winter even cross-country ski.',
    introductionButton: 'More about the house',
    introductionButtonTarget: '/thehouse',
    introductionSlider1Alt: 'The house',
    introductionSlider2Alt: 'Dining room',
    introductionSlider3Alt: 'Terrace with veranda',
    introductionSlider4Alt: 'Trampoline',
    introductionSlider5Alt: 'Nature in summer',
    introductionSlider6Alt: 'Nature in winter',
    reviewsTitle: 'Reviews and experiences',
    reviewsP1: '"Every year we organize a family week. During this week we stay at a campsite in the South of the country and we make many hiking tours, bike rides and day trips to local attractions."',
    reviewsP2: '"Last year, one of my children asked: "Are we going to that same boring campsite again?". So this year we took the entire family to the Vulkaneifel and didn\'t regret it for a moment."',
    reviewsButton: 'Read more experiences on Micazu',
    reviewsButtonTarget: 'https://www.micazu.com/about-the-host/62981/?houseId=25188'
  }
}

export default localization



// WEBPACK FOOTER //
// ./src/localization/home.js